module.exports = __webpack_public_path__ + "static/media/processometer-six.79c325ad.png";